module.exports = __webpack_public_path__ + "img/ganhe_tempo_icon.f39be483.svg";